/// <reference path="../global.d.ts" />

namespace MACRAIL.Business {

export class PostcodeService {

    private static cache: TravelInformation[] = [];

    public static getTravelInformation(from: string, to: string, callback: Function) {

        let cacheKey = `${from}-${to}`;
        let request: TravelRequest;

        // Check local cache
        if (PostcodeService.cache[cacheKey]) {
            request = PostcodeService.cache[cacheKey];

            if (request.complete) {
                // If AJAX request is already complete, just call the callback.
                callback(request.info);
            } else {
                // If AJAX is still running, save callback.
                request.callbacks.push(callback);
            }
            return;
        }


        // Not in cache, so fire off a request.
        request = {
            'callbacks': [
                callback,
            ],
            'complete': false,
            'info': {
                'from': from,
                'to': to,
                'valid': false,
                'distance': 0,
                'duration': 0,
            },
        };
        PostcodeService.cache[cacheKey] = request;

        let ajaxRequest = MACRAIL.Ajax.postController(
            'comRegisterSignIn',
            '_travelInformation',
            {
                'from': from,
                'to': to,
            });

        ajaxRequest.always(function(data, status, jqXhr) {
            request.complete = true;

            // If all succeeded, then save and return
            if (status === 'success' && data.status && data.status === 'success') {
                let info = data.message;

                // Save information
                request.info.valid = true;
                request.info.distance = info.distance;
                request.info.duration = info.duration;

                // Notify all callbacks waiting.
                for (let requstCallback of request.callbacks) {
                    requstCallback(request.info);
                }
                // Clear callbacks
                request.callbacks = [];
            } else {
                // Notify all callbacks waiting.
                for (let requstCallback of request.callbacks) {
                    requstCallback(request.info);
                }
                // Clear callbacks
                request.callbacks = [];
            }
        });
    }
}

interface TravelRequest {
    callbacks: Function[];
    complete: boolean;
    info: TravelInformation;
}

interface TravelInformation {
    from: string;
    to: string;
    valid: boolean;
    distance: number;
    duration: number;
}

}
